// extracted by mini-css-extract-plugin
export default {"image":"styles_image__0-OpX","content":"styles_content__1bxCJ","content2":"styles_content2__VGVRe","content3":"styles_content3__y3Hcd","more":"styles_more__hxjVl"};